import React from 'react'
import {
  presenceErrorClass,
} from 'servos/formValidations'

class Checkbox extends React.Component {
  componentDidMount() {
    const { savedTypes, id } = this.props
    savedTypes.forEach((type) => {
      if (type == id) {
        return document.querySelector('#'+id).checked = true
      }
    })
  }
  componentWillUpdate(nextProps, nextState) {
    const { savedTypes, id } = nextProps
    document.querySelector('#'+id).checked = savedTypes.includes(id)
  }

  render() {
    const {
      errorMessage,
      label,
      id,
      onClick,
    } = this.props

    return (
      <div>
        <div className='custom-control custom-checkbox mb-1'>
          <input id={id} className='custom-control-input' type='checkbox' onClick={onClick}/>
          <label className='custom-control-label' htmlFor={id}>
            <span>{label}</span>
          </label>
        </div>
        {this.props.children}
      </div>
    )
  }
}

export default Checkbox;
